import List from './views/List.vue'
import CreateUpdate from './views/CreateEdit.vue'

export const SubscriptionManagementRoutes = [
  {
    path: '/subscriptions-management',
    name: 'ListSubscriptionsManagement',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'trigger:list'
    }
  },
  {
    path: '/subscription-management',
    name: 'CreateSubscriptionManagement',
    component: CreateUpdate,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'trigger:create'
    }
  },
  {
    path: '/subscription-management/:id',
    name: 'UpdateSubscriptionManagement',
    component: CreateUpdate,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'trigger:update'
    }
  }
]
